import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DatabaseService } from '../services/database.service';
import { FirebaseTourModel } from '../data-model/tour.model';
import { FirebaseUserModel } from '../data-model/user.model';
import { AlertService } from '../services/alert.service';
import { ProfileTypes } from '../utilities';
import { DomSanitizer } from '@angular/platform-browser';
import { StorageService } from '../services/storage.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

  uid = null;
  userData = new FirebaseUserModel();
  userDataCopy = new FirebaseUserModel();
  modoVisualizacion = 'vista';
  profileTypes = ProfileTypes;
  toursCreados = [];
  userImageFile = null;
  userImageFileName = null;
  userImageUrlSanitizer = null;

  constructor(
    private route: ActivatedRoute,
    private db: DatabaseService,
    private storage: StorageService,
    public auth: AuthService,
    private alert: AlertService,
    private sanitizer: DomSanitizer
  ) { }

  async _getUserCreatedTours() {
    const createdToursData = await this.db.getUserTours(this.uid).get().toPromise();
    if (createdToursData) {
      var createdTourArray = [];
      createdToursData.forEach(ctd => {
        var tourCreado = ctd.data();
        tourCreado['id'] = ctd.id;
        const tourModel = FirebaseTourModel.objectToModel(tourCreado);
        console.log(tourModel);
        if (tourModel.imageUrl) {
          tourModel.imageSanitizer = this.sanitizer.bypassSecurityTrustResourceUrl(tourModel.imageUrl);
        }
        else{
          tourModel.imageSanitizer=null;
        }
        createdTourArray.push(tourModel);
        
      });
      this.toursCreados = createdTourArray;
      console.log(this.toursCreados);
    }
  }

  async ngOnInit(): Promise<void> {

    const user = await this.auth.getCurrentUserAlt();
    // Usuario logueado
    if (user) {
      this.uid = user.uid;
      const data = await this.db.getUser(this.uid).get();
      if (data) {
        // Datos usuario logueado BBDD
        var userData = data.data() || undefined;
        if (userData) {
          this.userData = FirebaseUserModel.objectUserToModel(userData);
          if (this.userData.imageUrl) {
            this.userImageUrlSanitizer = this.sanitizer.bypassSecurityTrustResourceUrl(this.userData.imageUrl);
          }else{
            this.userImageUrlSanitizer = null;
          }
          // Llamar a recuperar los tours creados por el usuario
          this._getUserCreatedTours();
        }
      }
    }
  }

  onEdit() {
    this.modoVisualizacion = 'edicion';
    this.userDataCopy = FirebaseUserModel.objectUserToModel(this.userData.toObject());
    console.log(this.userDataCopy);
  }

  onCancel() {
    this.modoVisualizacion = 'vista';
    if (this.userData.imageUrl != null) {
      this.userImageUrlSanitizer = this.sanitizer.bypassSecurityTrustResourceUrl(this.userData.imageUrl);
    }
    else {
      this.userImageUrlSanitizer = null; //Si el usuario no tenia imagen y ha Cancelado, le quito la imagen que ha cargado
    }
  }

  onCheckConvertirEnCreador(event) {
    this.userDataCopy.profile = event.target.checked === true ? ProfileTypes.Creador : ProfileTypes.Estandar;
  }

  async _uploadUserImage() {
    var userImageFileLocation = 'users/' + this.uid + '/' + this.userImageFileName; //Construyo la URL de la imagen en el Storage
    const file = await this.storage.upload(this.userImageFile, userImageFileLocation) //Primero lo tiene que subir al Storage
    if (file) {
      const url = await file.ref.getDownloadURL()
      if (url) {
        this.userDataCopy.imageUrl = url;
        this.userDataCopy.imageLocation = userImageFileLocation;
        this.userImageUrlSanitizer = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      }
    }
  }

  async onSave() {
    try {
      if (this.userImageFile) { //Si el usuario ha metido una imagen
        await this._uploadUserImage();
      }
      await this.db.createUpdateUser(this.uid, this.userDataCopy); 
      this.userData = this.userDataCopy;
      this.modoVisualizacion = 'vista';
      this.alert.showAlert("Actualizado", "Los datos del usuario se han actualizado correctamente", "success");

    } catch (error) {
      this.alert.showAlert("Error", JSON.stringify(error), "error");
    }

  }

  async onDeleteTour(id) {
    try{
      await this.db.deleteTour(id);
      await this._getUserCreatedTours();
      this.alert.showAlert("Eliminado", "El tour se ha eliminado correctamente", "success");

    }
    catch(error){
      this.alert.showAlert("Error", JSON.stringify(error), "error");
    }
    
  }

  getImage(event) {
    var file = event.target.files[0];
    this.userImageFile = file;
    this.userImageFileName = Date.now() + file.name;
    this.userImageUrlSanitizer = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(file));
  }
}
